import { useFormField, useFormContext } from '@calendly/form';
import { FieldError } from '@calendly/form/parts';
import { CloseMiniIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { useState, useEffect, useCallback, forwardRef } from 'react';
import { FieldBlock, Label } from './styles';
const styledInputCss = "s12j9y9c";
const StyledInput = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  return <Component ref={ref} {...restProps} className={classNames(styledInputCss, props.className)} />;
});
const validEmailCss = "vrv4o90";
const ValidEmail = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(validEmailCss, props.className)} />;
});
const invalidEmailCss = "i1uuzb0j";
const InvalidEmail = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(invalidEmailCss, props.className)} />;
});
const LabelAndEmailsWrapperCss = "l10837ey";
const LabelAndEmailsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(LabelAndEmailsWrapperCss, props.className)} />;
});
const styledCloseIconCss = "s17szllr";
const StyledCloseIcon = forwardRef((props, ref) => <CloseMiniIcon ref={ref} {...props} className={classNames(styledCloseIconCss, props.className)} />);
const FieldContainerCss = "f1o7qhoa";
const FieldContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(FieldContainerCss, props.className)} />;
});
const EmailsContainerCss = "e7af4yq";
const EmailsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(EmailsContainerCss, props.className)} />;
});
export const EmailToField = ({
  error,
  ...props
}) => {
  const {
    setFieldValue,
    setFieldError
  } = useFormContext();
  const [{
    name,
    value
  }] = useFormField(props);
  const [emails, setEmails] = useState(value.map(email => ({
    id: Math.random(),
    email
  })));
  const [newEmail, setNewEmail] = useState('');
  const [invalidEmails, setInvalidEmails] = useState([]);
  const errorMessage = typeof error === 'string' || typeof error === 'undefined' ? error : error.find(val => val && 'email' in val).email;
  useEffect(() => {
    setFieldError(name, '');
    setFieldValue(name, emails);
  }, [name, emails, setFieldValue, setFieldError, invalidEmails]);
  const addEmails = useCallback(() => {
    if (newEmail) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailsToAdd = newEmail.split(',').map(email => ({
        id: Math.random(),
        email: email.trim()
      }));
      const invalidEmailsToAdd = emailsToAdd.filter(({
        email
      }) => !emailRegex.test(email));
      setEmails(prevEmails => [...prevEmails, ...emailsToAdd]);
      if (invalidEmailsToAdd.length > 0) {
        setInvalidEmails(prevInvalidEmails => [...prevInvalidEmails, ...invalidEmailsToAdd]);
      }
      setNewEmail('');
    }
  }, [newEmail, setNewEmail]);
  const handleRemoveEmail = idToRemove => {
    setEmails(prevEmails => prevEmails.filter(({
      id
    }) => id !== idToRemove));
    setInvalidEmails(prevInvalidEmails => prevInvalidEmails.filter(({
      id
    }) => id !== idToRemove));
  };
  const handleNewEmailChange = event => {
    setNewEmail(event.target.value);
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      addEmails();
    }
  };
  return <FieldBlock data-component="to_field_block">
      <LabelAndEmailsWrapper>
        <FieldContainer>
          <Label htmlFor="to">To</Label>
          <EmailsContainer>
            {value.map(({
            id,
            email
          }) => !invalidEmails.map(({
            id: invalidId
          }) => invalidId).includes(id) ? <ValidEmail key={id}>
                {email}
                <StyledCloseIcon onClick={() => handleRemoveEmail(id)} />
              </ValidEmail> : <InvalidEmail key={id}>
                {email}
                <StyledCloseIcon onClick={() => handleRemoveEmail(id)} />
              </InvalidEmail>)}
            <StyledInput {...props} type="text" id="to_addresses" placeholder={emails.length === 0 ? 'enter email addresses, separated by a comma' : 'enter emails here'} onChange={handleNewEmailChange} onKeyDown={handleKeyDown} onBlur={addEmails} value={newEmail} />
          </EmailsContainer>
        </FieldContainer>
      </LabelAndEmailsWrapper>
      <FieldError text={errorMessage} id={errorMessage} />
    </FieldBlock>;
};

require("./email_to_field.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./email_to_field.js");